/*

@@author        j0Shi
@@date          2019.11.19
@@desc          search function helpers

*/
import { ref } from '@vue/composition-api';
import { redirectTo } from 'router/guards/navigationGuards';
import { getWhoamiData } from 'router/routes/whoami';
import { getDurationBetweenDates } from 'utils/DateHelper';

let timeout = null;
let affiliateRedirectTimeout = null;
let savedFilters = {};

// create affiliate compare link for matching hometogo / edom search
const htgCreateAffiliateLink = ((searchParams = {}) => {
  let affiliateLink = 'https://www.hometogo.de/affiliate/search/eDomizil';
  const searchParamsHtg = new URLSearchParams();

  const qParamHtg = searchParams?.query?.q || searchParams?.query?.fulltext;
  const tParamHtg = searchParams?.query?.t || '';
  if (qParamHtg) {
    searchParamsHtg.append('q', qParamHtg);
    if (tParamHtg) {
      searchParamsHtg.append('t', tParamHtg);
    }
  } else {
    // EDVUE-3660 fallback to prevent error on htg with empty search
    searchParamsHtg.append('q', 'Deutschland');
  }
  if (searchParams?.query?.startDate && searchParams?.query?.endDate) {
    searchParamsHtg.append('arrival', searchParams.query.startDate);
    const duration = getDurationBetweenDates(searchParams.query.startDate, searchParams.query.endDate);
    searchParamsHtg.append('duration', duration);
  }
  searchParamsHtg.append('persons', searchParams.query.persons || 2);
  searchParamsHtg.append('at', 'compare');

  if (searchParams?.query?.gclid) {
    searchParamsHtg.append('clickId', searchParams.query.gclid);
  }

  affiliateLink += `?${searchParamsHtg.toString()}`;

  return affiliateLink;
});
const affiliateRedirectLink = ref(false);

const searchRedirect = ({
  filters = {}, router, delay = 0, affiliateRedirect = false
}) => {
  // reset page
  if (Object.keys(filters).length && !Object.keys(filters).includes('page')) {
    filters.page = 1;
  }

  // EDVUE-3255 get all actual used filters before route change because they are not in router.currentRoute.query (line 55)
  if (router.currentRoute.name !== 'Search') {
    savedFilters = { ...router.app.$store.getters.getMergedTerms };
  }

  // save filters to make sure cancelled requests also get processed later
  savedFilters = {
    ...savedFilters,
    ...filters,
  };
  // // check for search component
  // let routeName = 'search';
  // const currentRouteComponentName = router.currentRoute?.matched[0]?.components?.default?.name;
  // if (currentRouteComponentName && typeof currentRouteComponentName === 'string') {
  //   routeName = currentRouteComponentName !== 'Search' ? 'Search' : router.currentRoute.name;
  // } else {
  //   // sometimes checking for the matched components name can return a Promise because routes are lazy-loaded, need a backup
  //   routeName = (router.currentRoute.name.match(/search/i) === null && router.currentRoute.path.match(/search/i) === null) ? 'search' : router.currentRoute.name;
  // }

  // const routeName = 'search';
  // clear timeout if a timeout is active
  if (timeout) clearTimeout(timeout);
  if (affiliateRedirectTimeout) clearTimeout(affiliateRedirectTimeout);
  const whoamiData = getWhoamiData(router.currentRoute, router.app.$store);

  // delay request
  timeout = setTimeout(() => {
    const searchRedirectParams = {
      name: 'Search',
      params: router.currentRoute.params,
      query: {
        // kill partner id because it's only required for the first load
        ...Object.keys(router.currentRoute.query).filter((el) => el.toLowerCase() !== 'pid').reduce((aggr, current) => {
          aggr[current] = router.currentRoute.query[current];
          return aggr;
        }, {}),
        ...(whoamiData?.datas ? whoamiData.datas : {}),
        ...savedFilters,
      },
      hash: '#searchResult',
    };
    // delete parameter t which is only for HTG redirect
    const searchRedirectParamsCleaned = JSON.parse(JSON.stringify(searchRedirectParams));
    delete searchRedirectParamsCleaned?.query?.t;

    if (affiliateRedirect) {
      const newTabSearch = router.resolve(searchRedirectParamsCleaned);
      window.open(newTabSearch.href, '_blank');
      affiliateRedirectLink.value = htgCreateAffiliateLink(searchRedirectParams);
      router.app.$store.state.affiliateRedirectLink = affiliateRedirectLink.value;
      affiliateRedirectTimeout = setTimeout(() => {
        router.push(redirectTo({ name: 'AffiliateRedirect' }));
      }, 2000);
      // router.app.$store.state.app.router.lastAppHeight = router.app.$el.scrollHeight;
    } else {
      router.push(redirectTo(router.currentRoute, searchRedirectParamsCleaned));
      // clear filters once routed
      savedFilters = {};
    }
  }, delay);
};

export default searchRedirect;
